import { render } from "./addAKSK.vue?vue&type=template&id=44e835a4"
import script from "./addAKSK.vue?vue&type=script&lang=js"
export * from "./addAKSK.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__